// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"53476cbf","977":"4034ba5a"}[chunkId] + ".chunk.js";
};